import { File, FileService, User } from '../api';

interface FilesProviderResource {
  getList: (
    resource: string,
    params: any
  ) => Promise<{ data: File[]; total: number }>;
  getOne: (resource: string, params: any) => Promise<{ data: {} }>;
  create: (resource: string, params: any) => Promise<{ data: File }>;
  update: (resource: string, params: any) => Promise<{ data: File }>;
  getMany: (resource: string, params: any) => Promise<{ data: File[] }>;
  getManyReference: (
    resource: string,
    params: any
  ) => Promise<{ data: User[] }>;
  updateMany: (resource: string, params: any) => Promise<{ data: File[] }>;
}

export const filesDataProvider: FilesProviderResource = {
  getList: async (resource, params) => {
    console.log('params: ', params);
    const { items } = await FileService.fileList();
    if (!items) {
      return {
        data: [],
        total: 0,
      };
    }
    return {
      data: items,
      total: items.length,
    };
  },
  getOne: async (resource, params) => {
    const { id } = params;
    const { data } = await filesDataProvider.getList(resource, {});

    return {
      data: data.find((item) => item.id === id) ?? {},
    };
  },
  create: async (resource, params) => {
    const file = await FileService.loadFile(
      params.data.file.title,
      params.data.file.rawFile
    );
    return {
      data: file,
    };
  },
  update: async (resource, params) => {
    const {
      data: { is_active, description, model_id },
    } = params;
    const file = await FileService.editFile(params.id, {
      is_active,
      description,
      model_id,
    });
    return {
      data: file,
    };
  },
  getMany: async (resource, params) => ({
    data: [],
  }),
  getManyReference: async (resource, params) => ({
    data: [],
  }),
  updateMany: async (resource, params) => ({
    data: [],
  }),
};
